import { render, staticRenderFns } from "./InvoiceGeneration.yaml?vue&type=template&id=48589f01&component"
import script from "./InvoiceGeneration.yaml?vue&type=script&lang=ts&component"
export * from "./InvoiceGeneration.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports